import i18n from 'i18next'
import unit from './config/unit'

export const shapeLocations = (results) => {
  const cities = results.cities
  const detailPostcodes = []
  const detailNeighborhoods = []
  const detailAddresses = []
  results.postcodes.forEach(item => detailPostcodes.push([item.postcode, item.city]))
  results.neighborhoods.forEach(item => detailNeighborhoods.push([item.neighborhood, item.city]))
  results.addresses.forEach(item => detailAddresses.push([item.address, item.city]))
  return {
    cities: cities,
    postcodes: detailPostcodes,
    neighborhoods: detailNeighborhoods,
    addresses: detailAddresses
  }
}

export const filterLocations = (locationsPayload, value, searchValues) => {
  const locations = {
    cities: [],
    addresses: [],
    neighborhoods: [],
    postcodes: [],
  }

  filterLocationType(
    'city',
    locationsPayload.cities,
    value,
    locations,
    searchValues
  )
  filterLocationType(
    'neighborhood',
    locationsPayload.neighborhoods,
    value,
    locations,
    searchValues
  )
  filterLocationType(
    'address',
    locationsPayload.addresses,
    value,
    locations,
    searchValues
  )
  filterLocationType(
    'postcode',
    locationsPayload.postcodes,
    value,
    locations,
    searchValues
  )

  return [
    ...locations.cities,
    ...locations.addresses,
    ...locations.neighborhoods,
    ...locations.postcodes,
  ]
}

const filterLocationType = (type, typeArr, value, locations, searchValues) => {
  const search = value.toLowerCase()

  for (let i = 0; i < typeArr.length; i++) {
    // return max 5 suggestions at a time
    if (
      locations.cities.length +
        locations.addresses.length +
        locations.neighborhoods.length +
        locations.postcodes.length >
      4
    )
      break
    const location = { type }
    switch (type) {
      case 'city':
        if (typeArr[i].toLowerCase().indexOf(search) >= 0) {
          location.value = location.display = typeArr[i]
          if (!searchValues.city.includes(typeArr[i]))
            locations.cities.push(location)
        }
        break
      case 'postcode':
        if (typeArr[i][0].toLowerCase().indexOf(search) >= 0) {
          location.value = `${typeArr[i][0]}`
          location.display = `${typeArr[i][0]}, ${typeArr[i][1]}`
          if (!searchValues.postcode.includes(typeArr[i][0]))
            locations.postcodes.push(location)
        }
        break
      case 'neighborhood':
        if (
          typeArr[i][0].toLowerCase().indexOf(search) >= 0 ||
          typeArr[i][1].toLowerCase().indexOf(search) >= 0
        ) {
          location.value = `${typeArr[i][0]}`
          location.display = `${typeArr[i][0]}, ${typeArr[i][1]}`
          if (!searchValues.neighborhood.includes(typeArr[i][0]))
            locations.neighborhoods.push(location)
        }
        break
      case 'address':
        if (
          typeArr[i][0].toLowerCase().indexOf(search) >= 0 ||
          typeArr[i][1].toLowerCase().indexOf(search) >= 0
        ) {
          location.value = `${typeArr[i][0]}`
          location.display = `${typeArr[i][0]}, ${typeArr[i][1]}`
          if (!searchValues.address.includes(typeArr[i][0]))
            locations.addresses.push(location)
        }
        break
      default:
        break
    }
  }
}

export const toArray = (value) => {
  if (!Array.isArray(value)) return [value]
  return value
}

export const updateLabel = (
  filterLabel,
  key,
  value,
  checkbox_category,
  country,
  t
) => {
  switch (key) {
    case 'room':
      if (value.length > 1) {
        filterLabel[key] = `${value.length} ${t('choices')}`
      } else if (value.length === 1) {
        filterLabel[key] = `${value[0]} ${t('room')}`
      } else {
        filterLabel[key] = t('Room')
      }
      break
    case 'category':
      if (value.length > 1) {
        filterLabel[key] = `${value.length} ${t('buildings')}`
      } else if (value.length === 1) {
        const label = checkbox_category.reduce(
          (label, item) =>
            // i18next-extract-disable-next-line
            item.value === value[0] ? label + t(item.label) : label,
          ''
        )
        filterLabel[key] = label
      } else {
        filterLabel[key] = t('Building')
      }
      break
    case 'price':
      const currency_unit = unit[country].currency_unit
      if (value.gte && value.lte) {
        filterLabel[
          key
        ] = `${value.gte} ${currency_unit} - ${value.lte} ${currency_unit}`
      }
      if (value.gte && !value.lte) {
        filterLabel[key] = `> ${value.gte} ${currency_unit}`
      }
      if (!value.gte && value.lte) {
        filterLabel[key] = `< ${value.lte} ${currency_unit}`
      }
      if (!value.gte && !value.lte) {
        filterLabel[key] = t('Price')
      }
      break
    case 'area':
      if (value.gte && value.lte) {
        filterLabel[key] = `${value.gte} m² - ${value.lte} m²`
      }
      if (value.gte && !value.lte) {
        filterLabel[key] = `> ${value.gte} m²`
      }
      if (!value.gte && value.lte) {
        filterLabel[key] = `< ${value.lte} m²`
      }
      if (!value.gte && !value.lte) {
        filterLabel[key] = t('Area')
      }
      break
    default:
      break
  }
  return filterLabel
}

export const updateLocationLabel = (filterLabel, query, t) => {
  const locations = [
    ...query.city,
    ...query.postcode,
    ...query.neighborhood,
    ...query.address,
  ]
  if (locations.length > 0) {
    filterLabel['search'] = `${locations.length} ${
      locations.length === 1 ? t('Location') : t('locations')
    }`
  } else {
    filterLabel['search'] = t('Location')
  }
  return filterLabel
}

export const getCategoryDisplay = (category) => {
  return {
    'apartment_house': i18n.t('Apartment house', { ns: 'common' }),
    'terraced_house': i18n.t('Terraced house', { ns: 'common' }),
    'semidetached_house': i18n.t('Semi-detached house', { ns: 'common' }),
    'detached_house': i18n.t('Detached house', { ns: 'common' }),
    'linked_house': i18n.t('Linked house', { ns: 'common' }),
  }[category]
}

export const getCurrencyDisplay = (currency) => {
  return {
    'EUR': '€',
    'SEK': 'kr',
    'NOK': 'kr',
    'DKK': 'kr'
  }[currency]
}

export const getCurrencyDisplayFromCountry = (country) => {
  return getCurrencyDisplay({
    'FI': 'EUR',
    'SE': 'SEK',
    'NO': 'NOK'
  }[country])
}

export const getConditionDisplay = (condition) => {
  return {
    'new': i18n.t('New', { ns: 'valuation' }),
    'excellent': i18n.t('Excellent', { ns: 'valuation' }),
    'good': i18n.t('Good', { ns: 'valuation' }),
    'satisfactory': i18n.t('Satisfactory', { ns: 'valuation' }),
    'poor': i18n.t('Poor', { ns: 'valuation' }),
    'unlivable': i18n.t('Unlivable', { ns: 'valuation' }),
    'unknown': i18n.t('Unknown', { ns: 'valuation' })
  }[condition]
}

export const getRoomDisplay = (room_count) => {
  room_count = Number(room_count)
  if (Number.isInteger(room_count)) {
    return `${room_count.toFixed()} ${i18n.t('rm', { ns: 'listings' })}`
  }
  return `${room_count.toString().replaceAll('.', ',')} ${i18n.t('rm', { ns: 'listings' })}`
}

export const getAreaDisplay = (area_living, area_unit) => {
  area_living = Number(area_living)
  if (Number.isInteger(area_living)) {
    return `${area_living.toFixed()} ${area_unit ? area_unit : 'm²'}`
  }
  return `${area_living.toFixed(2).toString().replaceAll('.', ',')} ${area_unit ? area_unit : 'm²'}`
}
